import script from "./AppError.vue?vue&type=script&setup=true&lang=js"
export * from "./AppError.vue?vue&type=script&setup=true&lang=js"

import "./AppError.vue?vue&type=style&index=0&id=396fc73c&lang=css"

const __exports__ = script;

export default __exports__